module.exports = __webpack_public_path__ + "static/img/image068.3482fae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image068.png
// module id = CfiT
// module chunks = 1